import { da } from "date-fns/locale";
import { Delete } from "lucide-react";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Trash2 } from 'lucide-react';
import axios from "../../utils/axios";
import UseAxiosPrivate from "../../hooks/useAxiosPrivate";
// import  { axiosPrivate } from "../../hooks/useAxiosPrivate";

const AgentTemplatePopup = ({ isTempOpen, onClose,ageList,setAgeList,setSchedList2,agentList,agentList2,setAgentList2,setAgentList,fetchAgentTeamplates,props }) => {

    const [searchTerm, setSearchTerm] = useState('');
    const [searchTerm2, setSearchTerm2] = useState('');
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedOption2, setSelectedOption2] = useState(null);
    const [showMenu, setShowMenu] = useState(false);
    const [showMenu2, setShowMenu2] = useState(false);

    const [selectedAgent,setSelectedAgent] = useState(0);

    const [templateData,setTemplateData]=useState([]);

    const axiosPrivate = UseAxiosPrivate();

    const handleDelete = async (index, id) => {
      
        Swal.fire({
            title: "Are you sure to Delete ?",
            text: "This Agent will be deleted from your Agent list",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Delete",
        }).then(async (result) => {
            if (result.isConfirmed) {
            
                setTemplateData(prev =>
                    (prev || []).filter((_, i) => i !== index)
                );
                
                Swal.fire(
                'Deleted!',
                'Agent has been deleted.',
                'success'
                );
            
            }
        })
    };

    useEffect(()=>{
        // fetchAgentTeamplates();
    },[])
    
    if (!isTempOpen) return null;

    const filteredOptions = (agentList || []).filter(option =>
        (option?.name || "").toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);
        setShowMenu(true);
    };

    const handleOptionSelect = async(option) => {
        // alert(option.id)
        setSelectedOption(option);
        setSearchTerm(option.name); // Show selected label in input
        setShowMenu(false); // Hide menu after selection
        
        try{
            const res = await axiosPrivate.get(`${process.env.REACT_APP_API_URL}/contactcentre/agent_template_agents/${option.id}`)

            
            if(res.status===200){
                console.log(JSON.stringify(res.data))
                setAgeList(res.data)
                setTemplateData(res.data);
                setSelectedAgent(option.id)
            }

        }catch(error){
            setTemplateData([]);
            Swal.fire(
                'Warning!',
                `${error.response.data?.error || 'Something Went wrong. Try Again.'}`,
                'warning'
            );
        }
        
    };

    const toggleMenu = () => {
        setShowMenu(!showMenu);
    };

    // alert(JSON.stringify(agentList2))

    const filteredOptions2 = (agentList2 || [])
        // remove agents already in templateData
        .filter(item =>
            !(templateData || []).some(t => t.id === item.id)
        )
        // apply search
        .filter(option =>
            (option?.agent_name || "")
            .toLowerCase()
            .includes((searchTerm2 || "").toLowerCase())
        );

    const handleInputChange2 = (e) => {
        setSearchTerm2(e.target.value);
        setShowMenu2(true);
    };

    const handleOptionSelect2 = async(option) => {
        // alert(option.id)
        setSelectedOption2(option);
        setShowMenu2(false); // Hide menu after selection
        
        setTemplateData((prev) => [
            ...prev,
            { id: option.id, agent_name: option.agent_name }
        ]);
        
        setSearchTerm2(""); // Show selected label in input
    };

    const toggleMenu2 = () => {
        setShowMenu2(!showMenu2);
    };

    const handleBlur2 = () => {
        // Delay hiding menu to allow option selection
        setTimeout(() => setShowMenu2(false), 150);
    };

    
    const handleBlur = () => {
        // Delay hiding menu to allow option selection
        setTimeout(() => setShowMenu(false), 150);
    };
    
    const createAgentTemplate=async(id)=>{
        // id will be either 0 or id value 0 for creation other for updation
        
        // const formData = new FormData();formData.append("scheduledTime",JSON.stringify(data.schedule_time));
        const formData = new FormData();
        formData.append("templateData",JSON.stringify(templateData));
        formData.append("agent_templates_name",JSON.stringify(searchTerm));
        try{
            const res = await axiosPrivate.post(`${process.env.REACT_APP_API_URL}/contactcentre/agent_template_agents/${id}`,formData)
            if(res.status===200){
                Swal.fire(
                    `${res?.data?.success.includes('Created')?'Created':'Updated'}!`,
                    `${res?.data?.success}`,
                    'success'
                );
                onClose()
                clearForm()
                fetchAgentTeamplates();
            }else{
                Swal.fire(
                    'Warning!',
                    'Something went wrong',
                    'warning'
                );
            }
        }catch(error){
            Swal.fire(
                'Warning!',
                `${error.response.data?.error || 'Something went wrong'}`,
                'warning'
            );
        }
    }

    const deleteAgentTemplate=async()=>{
        // id will be either 0 or id value 0 for creation other for updation
        
        // const formData = new FormData();formData.append("scheduledTime",JSON.stringify(data.schedule_time));
        const agent_template_id = parseInt(selectedAgent);
        if(agent_template_id==0){
            Swal.fire(
                'Warning!',
                'Please select a template to delete.',
                'warning'
            );
            return;
        }
        try{
            const res = await axiosPrivate.delete(`${process.env.REACT_APP_API_URL}/contactcentre/agent_template/`,{params:{id:agent_template_id}})
            if(res.status===200){
                Swal.fire(
                    `Deleted`,
                    `${res?.data?.success}`,
                    'success'
                );
                onClose()
                clearForm()
                fetchAgentTeamplates();
            }else{
                Swal.fire(
                    'Warning!',
                    'Something went wrong',
                    'warning'
                );
            }
        }catch(error){
            Swal.fire(
                'Warning!',
                `${error.response.data?.error || 'Something went wrong'}`,
                'warning'
            );
        }
    }
    
    const clearForm=()=>{
        setTemplateData([]);
        setSearchTerm('');
    }
    
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
            <div className="bg-white rounded-xl shadow-xl w-[55rem] p-6 pr-1">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold">Add Agent Template</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700 pr-3"
                        >
                        ✕
                    </button>
                </div>

                {/* overflow start */}
                <div className="overflow-y-auto max-h-[27.5rem] min-h-[22.5rem]">                            

                            <div className="flex space-x-4">
                                
                                <div className="flex space-x-5">
                                    <div className="relative mr-[5.5rem]">
                                        <h1 className="text-md text-slate-400 pt-4">Agent Template Name</h1>
                                        
                                        <div className="relative w-80">
                                            {/* Searchable Input */}
                                            <input
                                                type="text"
                                                value={searchTerm}
                                                onChange={handleInputChange}
                                                onClick={toggleMenu}
                                                onBlur={handleBlur}
                                                placeholder="Select Agent Template"
                                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-80 pl-4 p-2.5 w-[25rem]"
                                            />

                                            <span className="absolute right-[-4rem] top-1/2 -translate-y-1/2 text-gray-400 cursor-pointer" onClick={()=>setSearchTerm("")}>
                                                <small className="text-red-400 hover:text-red-500 focus:text-red-400">Clear</small>
                                            </span>
                                        </div>

                                        {/* Dropdown Menu */}
                                        {showMenu && (
                                            <ul
                                            className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto z-10 w-[25rem]"
                                            onMouseDown={(e) => e.preventDefault()} // Prevent input blur when interacting with dropdown
                                            >
                                            {filteredOptions.map((option) => (
                                                <li
                                                key={option.id}
                                                onClick={() => handleOptionSelect(option)} // Handle option selection
                                                className="cursor-pointer py-2 px-4 hover:bg-gray-200"
                                                >
                                                {option.name}
                                                </li>
                                            ))}
                                            {filteredOptions.length === 0 && (
                                                <li className="py-2 px-4 text-gray-500">No options found</li>
                                            )}
                                            </ul>
                                        )}
                                    </div>
                                </div>

                                <div className="flex items-end">
                                    <div className="relative">
                                        <h1 className="text-md text-slate-400 pt-4">Select Agent</h1>
                                        
                                        {/* Searchable Input */}
                                        <input
                                            type="text"
                                            value={searchTerm2}
                                            onChange={handleInputChange2}
                                            onClick={toggleMenu2}
                                            onBlur={handleBlur2}
                                            placeholder="Select Agent"
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-80 pl-4 p-2.5 w-[25rem]"
                                        />

                                        {/* Dropdown Menu */}
                                        {showMenu2 && (
                                            <ul
                                            className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto z-10"
                                            onMouseDown={(e) => e.preventDefault()} // Prevent input blur when interacting with dropdown
                                            >
                                            {filteredOptions2.map((option) => (
                                                <li
                                                key={option.id}
                                                onClick={() => handleOptionSelect2(option)} // Handle option selection
                                                className="cursor-pointer py-2 px-4 hover:bg-gray-200"
                                                >
                                                {option.agent_name}
                                                </li>
                                            ))}
                                            {filteredOptions2.length === 0 && (
                                                <li className="py-2 px-4 text-gray-500">No options found</li>
                                            )}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                                
                            </div>
                        
                            <div className="mt-12">
                                <div className="flex justify-between mb-1">
                                    <h3 className="font-bold pl-[0.75rem]">Agent List</h3>
                                    <button onClick={()=>setTemplateData([])} className="px-[0.5rem] py-[0.1rem] text-sm bg-red-600 text-white rounded-md hover:bg-red-700 transition mr-[1.7rem]"><small>Clear</small></button>
                                </div>

                                    <table className="min-w-full text-sm">
                                        <thead className="border-b rounded" style={{backgroundColor:"#0000001a"}}>
                                            <tr>
                                                {/* <th>ID</th> */}
                                                <th className="pr-0 pl-[1.5rem] py-4 font-bold text-gray-700">No.</th>
                                                <th className="pl-[4rem] py-4 font-bold text-gray-700 text-start">Agent</th>
                                                <th className="pr-[5rem] py-4 font-bold text-gray-700 text-end">Action</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <div className="relative overflow-x-hidden mt-0 max-h-[22rem]">

                                            <table className="min-w-full text-sm  ">
                                                <tbody>
                                                {templateData.map((obj, index) => (
                                                    <tr key={obj.id ?? `temp-${index}`} className="border-b hover:bg-gray-50 transition-colors">
                                                        {/* <td>{obj.id}</td> */}
                                                        <td className="px-6 pl-[5rem] py-3 text-gray-700 font-mono w-[5rem]">
                                                            {index+1}
                                                        </td>
                                                        <td className="px-6 py-3 text-gray-700 font-mono pl-[6rem]">
                                                            {obj.agent_name}
                                                        </td>
                                                        <td className="px-6 pr-4 py-3 text-right">
                                                            <div className="flex justify-end pr-[4.5rem]">
                                                                <button
                                                                onClick={() => handleDelete(index, obj.id)}
                                                                className="inline-flex items-center justify-center w-8 h-8 rounded-full text-red-500 hover:bg-red-50 hover:text-red-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-red-200"
                                                                aria-label={`Delete schedule ${obj}`}
                                                                title="Delete schedule"
                                                                >
                                                                <Trash2
                                                                    className="text-red-600 w-4 h-4"
                                                                    strokeWidth={2}
                                                                />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                                {templateData.length<=0? 
                                                    <tr>
                                                        <td className="pr-[0rem] pl-[3rem] py-3 text-gray-700 font-bold ">
                                                            -No Data-
                                                        </td>
                                                        <td className="pr-[13.5rem] pl-[1.5rem] py-3 text-gray-700 font-bold text-start">
                                                            -No Data-
                                                        </td>
                                                        <td className="pr-[4.5rem] pl-[0rem] py-3 text-gray-700 font-bold text-end">
                                                            -No Data-
                                                        </td>
                                                    </tr>
                                                :''}
                                                </tbody>
                                            </table>
                                    </div>
                            </div>

                            {/* <hr className="mt-5"></hr> */}

                </div>
                {/* overflow end */}

    
                <div className="flex space-x-4 mt-5">

                    <div className="w-[12.5rem]"></div>

                    <div className="">
                        <button
                            onClick={()=>createAgentTemplate(0)}
                            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold h-10 px-6 rounded-lg mr-5"
                        >
                            Create
                        </button>

                        <button
                            onClick={()=>createAgentTemplate(1)}
                            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold h-10 px-6 rounded-lg mr-5"
                        >
                            Update
                        </button>

                        <button
                            onClick={()=>deleteAgentTemplate()}
                            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold h-10 px-6 rounded-lg mr-5"
                        >
                            Delete
                        </button>

                        <button
                            onClick={onClose}
                            className="bg-red-600 hover:bg-red-700 text-white font-semibold h-10 px-6 rounded-lg"
                        >
                            Cancel
                        </button>
                    </div>
                </div>



            </div>
        </div>
    );
};

export default AgentTemplatePopup;